<mwe-pre-load-data
  [state]="state()"
  [successTemplate]="success"
  alertMessageKey="error.service.default.message"
  alertTitleKey="error.service.default.title"
/>

<ng-template #success>
  @if (hasNoAddress()) {
    <mwe-no-associations-found-warning
      [navigatingBackTo]="navigatingBackTo()"
      [noAddressGroupsTitle]="noAddressGroupsTitle()"
      [noAddressGroupsText]="noAddressGroupsText()"
    />
  } @else {
    @for (item of addressMultiProductCards(); track item.address?.hashCode + $index) {
      <div class="mb-4 mb-lg-5">
        <mwe-address textNodeType="h2" [address]="item.address" />
      </div>

      <div class="row g-4 mb-5 mb-lg-6">
        @for (card of item.multiProductCards; track $index) {
          <div class="col-lg-6">
            <mwe-basic-card-clickable (cardClicked)="onMultiCardClicked(item, card)">
              <div class="mb-2">
                <mwe-product-icons size="2xl" textNodeType="h3" [categories]="card.categories" />
              </div>
              <p class="mb-2"><strong [translate]="card.displayAccountNumberLabel"></strong>: {{ card.displayAccountNumber }}</p>
              <p class="text--legal mb-0">{{ card.categories[0] | correlatedCompanyReference }}</p>
            </mwe-basic-card-clickable>
          </div>
        }
      </div>
    }
  }
</ng-template>
